import { createContext, useContext, useReducer } from "react";

import PropTypes from "prop-types";

const AuthContext = createContext();

AuthContext.displayName = "AuthContext";

function reducer(state, action) {
  switch (action.type) {
    case "ACCESS_TOKEN": {
      localStorage.setItem("accessToken", action.value);
      return { ...state, accessToken: action.value };
    }
    case "REFRESH_TOKEN": {
      localStorage.setItem("refreshToken", action.value);
      return { ...state, refreshToken: action.value };
    }
    case "IS_AUTHENTICATED": {
      return { ...state, isAuthenticated: action.value };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

const getAccessToken = () => {
  const accessToken = localStorage.getItem("accessToken");
  if (accessToken && accessToken !== "null") {
    return accessToken;
  }
  return null;
};
const getRefreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (refreshToken && refreshToken !== "null") {
    return refreshToken;
  }
  return null;
};

const logout = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

function AuthControllerProvider({ children }) {
  const initialState = {
    accessToken: getAccessToken(),
    refreshToken: getRefreshToken(),
    isAuthenticated: !!getAccessToken() || !!getRefreshToken(),
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  return <AuthContext.Provider value={[controller, dispatch]}>{children}</AuthContext.Provider>;
}

function useAuthController() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuthController should be used inside the AuthControllerProvider.");
  }

  return context;
}

AuthControllerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const setAccessToken = (dispatch, value) => dispatch({ type: "ACCESS_TOKEN", value });
const setRefreshToken = (dispatch, value) => dispatch({ type: "REFRESH_TOKEN", value });
const setIsAuthenticated = (dispatch, value) => dispatch({ type: "IS_AUTHENTICATED", value });
const updateTokens = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};

export {
  AuthContext,
  AuthControllerProvider,
  useAuthController,
  getAccessToken,
  setAccessToken,
  getRefreshToken,
  setRefreshToken,
  setIsAuthenticated,
  updateTokens,
  logout,
};
